const KEY = "endag1_recently_viewed";

export function getRecentlyViewed() {
  try {
    return JSON.parse(localStorage.getItem(KEY) || "[]");
  } catch {
    return [];
  }
}

export function addRecentlyViewed(product) {
  if (!product || !product.slug) return;
  const slim = { slug: product.slug, name: product.name, image: product.image, price: product.price, size: product.size, category: product.category };
  const list = getRecentlyViewed().filter((p) => p.slug !== product.slug);
  list.unshift(slim);
  localStorage.setItem(KEY, JSON.stringify(list.slice(0, 8)));
}
